function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'zutil', 'lodash.filter', 'hola_opt', '/util/url.js', '/www/hola/pub/pages_dict.js', '/util/events.js', '/www/hola/pub/util.js', '/svc/vpn/pub/common_ui.js', '/svc/account/pub/membership.js', '/util/string.js'], (React, _, _filter, hopt, zurl, pages_dict, events, www_util, common_ui, zmembership, zstring) => {
  var _E$all_plans;
  var qs_o = () => zurl.qs_parse(location.search.substr(1), {
    safe: true
  });
  var E = {};
  var ref = qs_o().ref || '';
  var useEffect = React.useEffect,
    useState = React.useState;
  E.all_plans = hopt.all_plans;
  E.all_plans_ids_map = {};
  (_E$all_plans = E.all_plans) === null || _E$all_plans === void 0 ? void 0 : _E$all_plans.forEach(p => E.all_plans_ids_map[p.id] = true);
  var fixed_plan_ids;
  var default_opt = {};
  var plus_util;
  var discount_plans = hopt.discount_plans || [];
  E.set_plus_util = _util => plus_util = _util;
  E.emitter = new events.EventEmitter();
  E.set_plans = plans => {
    var _E$all_plans2;
    E.all_plans = plans;
    E.all_plans_ids_map = {};
    (_E$all_plans2 = E.all_plans) === null || _E$all_plans2 === void 0 ? void 0 : _E$all_plans2.forEach(p => E.all_plans_ids_map[p.id] = true);
    E.emitter.emit('on_update_plans');
  };
  E.use_plans = () => {
    var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      refresh = _useState2[0],
      set_refresh = _useState2[1];
    useEffect(() => {
      var updater = () => set_refresh(count => count + 1);
      E.emitter.on('on_update_plans', updater);
      return () => E.emitter.removeListener('on_update_plans', updater);
    }, []);
    return refresh;
  };
  E.get_discount_plans = () => discount_plans;
  E.activate_discount_plans = (plans, base_plans = []) => {
    discount_plans = plans || [];
    var _iterator = _createForOfIteratorHelper(plans),
      _step;
    try {
      var _loop = function _loop() {
        var plan = _step.value;
        var _plan = E.all_plans.find(pl => pl.id == plan.id);
        if (!_plan) {
          _plan = Object.assign({}, plan);
          E.all_plans.push(_plan);
        }
        if (!_plan.base_plan) {
          var _iterator2 = _createForOfIteratorHelper(base_plans),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var p = _step2.value;
              if (_plan.id == p.fallback_plan) {
                plan.base_plan = _plan.base_plan = p.id;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        if (!_plan.base_plan) {
          var _iterator3 = _createForOfIteratorHelper(base_plans),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _p = _step3.value;
              if (_plan.period == _p.period && _plan.type == _p.type) {
                plan.base_plan = _plan.base_plan = _p.id;
                break;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    E.emitter.emit('on_update_plans');
  };
  E.is_plan_discount = p => {
    if (!p) return false;
    var is_active_discount = false;
    if (discount_plans) {
      discount_plans.forEach(pl => {
        if (pl.id == p.id) is_active_discount = true;
      });
    }
    return is_active_discount;
  };
  E.get_valid_message = () => {
    if (!discount_plans.length) return 'The code you inserted is not valid';
    var plans_info = E.get_plans_info([discount_plans[0].id]);
    var plan = plans_info[Object.keys(plans_info)[0]];
    var name = plan.short_name + ' ' + zstring.capitalize(zmembership.type2name[plan.type] || '') + ' plan';
    return `The code you inserted is only valid for the ${name}`;
  };
  E.set_fixed_plan_ids = plans => fixed_plan_ids = plans;
  E.clear_fixed_plan_ids = () => fixed_plan_ids = null;
  E.set_plan_opt = _opt => default_opt = _opt;
  E.get_plan_ids = opt => {
    var _qs_plan_ids, _hopt$uninstall$plan_, _hopt$uninstall;
    var _opt = _objectSpread(_objectSpread({}, default_opt), opt);
    if (fixed_plan_ids) return fixed_plan_ids;
    var _qs_o = qs_o(),
      fixed_id = _qs_o.fixed_id,
      qs_plan_ids = _qs_o.plan_ids;
    if (fixed_id) return [fixed_id];
    if (qs_plan_ids) qs_plan_ids = qs_plan_ids.split(' ').filter(p => E.all_plans_ids_map[p]);
    if ((_qs_plan_ids = qs_plan_ids) !== null && _qs_plan_ids !== void 0 && _qs_plan_ids.length) return qs_plan_ids;
    _opt.ultra = _opt.ultra || pages_dict.is_ultra_page();
    var is_plus_page = pages_dict.is_plus_page();
    var is_refund_promo = pages_dict.is_refund_exp();
    var annual_promo = pages_dict.is_uninstall_page() || pages_dict.is_annual_promo() || is_refund_promo;
    var annual_promo_full = pages_dict.is_annual_promo_full();
    var annual_promo_ids = (_hopt$uninstall$plan_ = (_hopt$uninstall = hopt.uninstall) === null || _hopt$uninstall === void 0 ? void 0 : _hopt$uninstall.plan_ids) !== null && _hopt$uninstall$plan_ !== void 0 ? _hopt$uninstall$plan_ : [];
    if (is_refund_promo) annual_promo_ids = hopt.refund_exp.plan_ids;
    var plan_ids;
    if (annual_promo && _opt.ultra) plan_ids = hopt.annual_promo_ultra.plan_ids;else if (_opt.ultra) plan_ids = hopt.ultra.plan_ids;else if (annual_promo_full) plan_ids = hopt.annual_promo_full.plan_ids;else if (annual_promo) plan_ids = annual_promo_ids;else if (is_plus_page) plan_ids = hopt.join_plus.plan_ids;else plan_ids = hopt.join_n.plan_ids;
    if (pages_dict.is_ni_get_hola()) plan_ids = hopt.ni_aff_plans.plan_ids;
    if (pages_dict.is_annual_get_hola()) plan_ids = hopt.annual_aff_plans.plan_ids;
    if (pages_dict.is_ultra_flash_special()) plan_ids = hopt.ultra_flash_special.plan_ids;
    if (ref == 'studentbeans') plan_ids.push('promo_y1', 'promo_y3');
    if (pages_dict.is_bogof_promo()) plan_ids = hopt.bogof_promo.plan_ids;
    if (pages_dict.is_kivoto_promo()) plan_ids = hopt.kivoto_promo.plan_ids;
    if (pages_dict.is_bogof_y_promo()) plan_ids = ['y12005_vd_promo'];
    if (pages_dict.is_dunning_promo()) plan_ids = hopt.dunning_promo.plan_ids;
    if (pages_dict.is_march_madness_promo_full()) plan_ids = hopt.mm_promo_full.plan_ids;else if (pages_dict.is_march_madness_promo()) plan_ids = hopt.mm_promo.plan_ids;
    return plan_ids;
  };
  E.get_base_discount = () => {
    if (pages_dict.is_ni_get_hola()) return hopt.ni_aff_plans.base_discount;
    if (pages_dict.is_annual_get_hola()) return hopt.annual_aff_plans.base_discount;
    return '';
  };
  E.get_discount_plan = pl => {
    if (pl && discount_plans) {
      var found = discount_plans.find(d_p => d_p.base_plan == pl.id);
      return found ? E.get_plan_info(found.id) : null;
    }
    return null;
  };
  var is_coupon_flow = () => ({
    '/join/stackcommerce': 1,
    '/join/groupon': 1
  })[location.pathname.toLowerCase()];
  E.get_coupon_flow = () => {
    if (ref == 'studentbeans') return 'promo_plan';
    if (is_coupon_flow()) return 'coupon';
  };
  E.merge_plans = (src, plans) => src.map(p => E.get_replaced_plan(p, plans).id);
  E.get_replaced_plan = (plan, plans) => {
    var _iterator4 = _createForOfIteratorHelper(plans),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var p = _step4.value;
        if (plan.period == p.period) return p;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return plan;
  };
  var get_qs_plan_ids = () => {
    var ids = qs_o().plan_ids;
    if (!ids) return;
    ids = ids.split(' ').filter(p => E.all_plans_ids_map[p]);
    if (!ids.length) return;
    return ids;
  };
  var get_replace_plan = qs_plan_ids => !(qs_plan_ids || get_qs_plan_ids()) && plus_util && plus_util.plans_ab_test && plus_util.plans_ab_test.replace;
  E.get_plans_info = (ids, opt = {}) => {
    var plans_info = {};
    var qs_plan_ids = get_qs_plan_ids();
    ids = ids || qs_plan_ids || hopt.payment.plan_ids;
    var replace_plan = get_replace_plan(qs_plan_ids);
    var plans = common_ui.fill_plans_info(ids, E.all_plans, {
      discount_base: E.get_base_discount(),
      replace_plan
    });
    if (replace_plan) plans.sort((a, b) => a.day_price - b.day_price);
    plans.forEach((p, i) => {
      var id = p.period;
      if (plans_info[id]) id = id + '_' + i;
      plans_info[id] = p;
    });
    return plans_info;
  };
  E.get_plan_info = id => common_ui.fill_plans_info([id], E.all_plans, {
    replace_plan: get_replace_plan()
  })[0];
  E.is_plan = opt => opt.is_plan;
  E.get_plans_info_obj = (opt = {}) => {
    if (E.is_plan(opt)) return opt;
    var ids = E.get_plan_ids();
    if (opt.id == 'coupon') return {
      id: opt.id,
      price: 0
    };
    if (opt.id && !ids.includes(opt.id)) ids = [...ids, opt.id];
    var plans = E.get_plans_info(ids);
    var filtered = _filter(plans, opt).sort((a, b) => a.day_price - b.day_price);
    return filtered[0];
  };
  E.get_min_price_plan = plans => _.min_by(plans, p => p.day_price);
  E.get_special_plans = plans => {
    var best = E.get_min_price_plan(plans);
    var popular = plans.find(p => p.period == (best.period == '1 Y' ? '1 M' : '1 Y'));
    return {
      best,
      popular
    };
  };
  return E;
});